// extracted by mini-css-extract-plugin
module.exports = {"caption":"caption_caption__1qjt7","captionRight":"caption_captionRight__3UGVu","captionCenter":"caption_captionCenter__3oajn","captionGreen":"caption_captionGreen__3tZAw"};